"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Download = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.997 11c-.266 0-.533-.102-.736-.303l-2.955-2.93a1.029 1.029 0 010-1.464 1.051 1.051 0 011.478 0L7 7.51V1a1 1 0 012 0v6.509l1.216-1.206a1.051 1.051 0 011.478 0 1.03 1.03 0 010 1.465l-2.955 2.929c-.203.201-.47.302-.736.303h-.006zM1 10a1 1 0 011 1v2a1 1 0 001 1h10a1 1 0 001-1v-2a1 1 0 112 0v2a3 3 0 01-3 3H3a3 3 0 01-3-3v-2a1 1 0 011-1z",
  fill: "#ACB3BE"
}));

var _default = Download;
exports.default = _default;